import { isoZ, z } from 'my-zod'
import { additionalQuestionResponse } from '../../customer-operations/reservation/additional-question-response'
import { getSelectCustomerInvoiceFromTransfers, getSelectCustomerInvoicePreview } from './get-select-customer-invoice'

const customErrorMap: z.ZodErrorMap = (error, ctx) => {
  if (error.code === z.ZodIssueCode.invalid_type) {
    return {
      message: 'Incorrect date format.'
    }
  }
  return { message: ctx.defaultError }
}

const createSelectCustomerOrder = z.object({
  id: z.string(),
  shortId: z.string(),
  outfitterId: z.number(),
  reservation: z.object({
    id: z.string(),
    productId: z.string(),
    beginDate: isoZ.date({ errorMap: customErrorMap }),
    endDate: isoZ.date({ errorMap: customErrorMap }),
    ridingStartTime: isoZ.time(),
    ridingEndTime: isoZ.time(),
    vehicles: z
      .object({
        id: z.string().uuid(),
        assetFamilyId: z.string(),
        signature: z.string().min(1),
        /**
         * not technically the time the row was inserted into the database, rather the time
         * the customer declared their intent to book (as represented by reservation vehicle create context)
         */
        quotedDate: isoZ.instant(),
        quotedDateLocal: isoZ.date(),
        quotedTimeLocal: isoZ.time(),
        numberOfUnitsAvailable: z.number().int().nonnegative()
      })
      .array()
      .min(1),
    additionalQuestionResponses: additionalQuestionResponse.array(),
    insuranceCarrier: z.string().nullish(),
    insurancePolicyNumber: z.string().nullish(),
    towingVehicleLicensePlateNumber: z.string().nullish()
  }),
  creditTotalEstimate: z.number()
})

export const SelectCustomerOrderSchemas = {
  createSelectCustomerOrder,
  getSelectCustomerInvoiceFromTransfers,
  getSelectCustomerInvoicePreview
}

export namespace SelectCustomerOrderSchemas {
  export type createSelectCustomerOrder = z.infer<typeof createSelectCustomerOrder>
  export type SelectCustomerInvoice = ReturnType<typeof getSelectCustomerInvoiceFromTransfers>
}
